import ACheckbox from './index.vue';

ACheckbox.install = app => {
  app.component(ACheckbox.name, ACheckbox);
};

export default ACheckbox;
